import { IReduxAction } from '@bees-web/core/types'
import { SET_OPENED_COLLAPSE_NAME } from '../constants'
import { IFaqState } from '../interfaces'

export const initialState: IFaqState = {
  openedCollapseName: null,
}

const faqReducer = (state: IFaqState = initialState, action: IReduxAction) => {
  if (action.type === SET_OPENED_COLLAPSE_NAME) {
    return {
      ...state,
      openedCollapseName: action.payload.openedCollapseName,
    }
  } else {
    return state
  }
}

export default faqReducer
